import React from "react";

export default function StepIntro({
  eyebrow,
  title,
  copy,
}: {
  eyebrow: string;
  title: string;
  copy: React.ReactNode;
}) {
  return (
    <div>
      <p className="tw-m-0 tw-text-xs tw-font-black tw-uppercase tw-tracking-[.15em] tw-text-[#087bd3]">
        {eyebrow}
      </p>
      <h3 className="tw-mt-3 tw-mb-0 tw-text-3xl tw-font-black tw-leading-tight tw-tracking-[-.03em] tw-text-[#173754] sm:tw-text-2xl">
        {title}
      </h3>
      <p className="tw-mt-3 tw-mb-0 tw-leading-7 tw-text-[#5b7188]">{copy}</p>
    </div>
  );
}
